import { collection, getDocs, setDoc, doc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { contracts as sampleContracts } from '../data/contracts';

export const initializeFirebaseData = async () => {
  try {
    // First check if we can access the users collection
    const usersRef = collection(db, 'users');
    const adminQuery = await getDocs(usersRef);
    
    // Only create admin if no users exist
    if (adminQuery.empty) {
      try {
        await setDoc(doc(db, 'users', 'admin'), {
          email: 'admin@example.com',
          name: 'Admin',
          role: 'admin',
          createdAt: new Date().toISOString()
        });
        console.log('Default admin user created');
      } catch (error) {
        // If we can't create the admin user, just log it and continue
        // This could happen if we have read but not write permissions
        console.warn('Could not create admin user:', error);
      }
    }

    // For now, we'll use the local data instead of trying to initialize Firestore
    console.log('Using local contract data');
    
    return true;
  } catch (error) {
    // If we can't access Firestore at all, log it and return false
    console.warn('Could not initialize Firebase data:', error);
    return false;
  }
};